import {
  CoreApi,
  ProductDesign,
  Product,
  IgnoreHighlightComponent,
  ReplacedFrameComponent
} from '@inter-ikea-storageone/range';
import { Entity } from '@inter-ikea-core/core';
import {
  getInteriorsInFrame,
  getReplacableOrgainizersInFrame,
  getReplaceableProduct,
  isIncludedShelfInsideCornerSolution
} from './utils';

export const changeFrameColor = (
  coreApi: CoreApi,
  frames: Entity[],
  design: ProductDesign,
  products: Product[]
): boolean => {
  let notReplaceableInteriorFound = false;
  frames.forEach(frame => {
    const interiors = getInteriorsInFrame(frame);

    const organizers = getReplacableOrgainizersInFrame(frame);
    const includedShelvesInCornerFrame = interiors.filter(interior =>
      isIncludedShelfInsideCornerSolution(interior)
    );
    const newFrame = getReplaceableProduct(frame, design, products);
    if (newFrame) {
      const result = coreApi.products.replace(frame.id, newFrame.coreProductId, true);
      const replacedFrame = result?.replacedEntityResult.placedEntity;
      if (result?.replacedEntityResult.valid && replacedFrame) {
        addReplacedFrameComponent(replacedFrame);
      }
      includedShelvesInCornerFrame.forEach(shelf => coreApi.entities.delete(shelf));
      [...interiors, ...organizers].forEach(interior => {
        if (!isIncludedShelfInsideCornerSolution(interior) && !interior.isDisposed) {
          const newInterior = getReplaceableProduct(interior, design, products);
          if (newInterior) {
            const replacePlacementResult = coreApi.products.replace(
              interior.id,
              newInterior.coreProductId,
              true
            );
            const newEntity = replacePlacementResult?.replacedEntityResult.placedEntity;
            if (newEntity) {
              newEntity.addComponent(new IgnoreHighlightComponent());
            }
          } else {
            notReplaceableInteriorFound = true;
          }
        }
      });
    }
  });
  return notReplaceableInteriorFound;
};

export const addReplacedFrameComponent = (frame: Entity) => {
  if (frame) {
    frame.addComponent(new ReplacedFrameComponent());
  }
};
